module.exports = __webpack_public_path__ + "static/media/nk-login-big-new-bg.55382878.jpg";